export default "__VITE_ASSET__d4e20898__"